import { useContext } from "react";

import { AuthenticationContext, IAuthentication } from "./AuthenticationContext";

export const useAuthentication = (): IAuthentication => {
  const context = useContext(AuthenticationContext);
  if (!context) {
    throw new Error("useAuthentication() must be used within a <AuthenticationProvider /> component.");
  }

  return context;
};
